<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y15KiO/tc-custom/9781464206306.jpg?1732163898105" alt="This image is the cover for the book This Isn't a Game, Jackson Oliver Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">This Isn't a Game, Jackson Oliver Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>A smart debut sends Jackson Oliver, head of online gambling casino VegasVegas, headquartered in San Jose, Costa Rica, to a New England village where he suspects someone has gotten away with murder—and used VegasVegas as part of the clever con. Jackson not only feels like a chump for accepting a bet that will cost VegasVegas a hundred grand, he's exposed the casino to blacklisting by the Offshore Gaming Association, which could ruin it.</p><p>How did this happen? It's a celebrity-obsessed age. VegasVegas posts novelty propositions so its customers can bet on the outcome of TV shows like <i>The Voice</i> and <i>The Bachelorette</i>, and on political elections and celebrity murder trials. VegasVegas customers don't want to bet on speeding tickets or misdemeanor theft. They're star-obsessed. Athlete, musician, actor, socialite—the more the victim or alleged perpetrator shows up on <i>TMZ</i>, the more money bettors fork out. So VegasVegas offered odds on various outcomes in the trial of a movie director accused of murdering his wife. The trial comes fourteen months after Andrew Marvel's arrest, and conviction seems certain. When a customer bets $1,000 that all charges will be dropped—an outcome so unlikely that the odds are 100 to 1—Jackson takes the bet.</p><p>Audrey Marvel was killed in the couple's lakeside summer home in Greensboro, Vermont. Audrey's blood was all over Andrew's clothes, which the police found at the bottom of the lake. Andrew's wild account that he'd been drugged with Doxepin and hijacked sounds like it was ghostwritten by the prosecutor. Yet two days after the bet made at VegasVegas, an unshakable video alibi for Andrew surfaces, proving the director was three hours away at the time of Audrey's murder. And all charges are dropped.</p><p>Jackson suspects the bettor, a Greensboro resident, had inside information—or worse—making the bet fraudulent and letting VegasVegas off the hook. With no time to lose proving his theory, Jackson hops a plane to Vermont. There, working undercover, he begins to investigate the Marvel murder. A ring of antique weathervane thieves and an attractive crime blogger with movie scripts in her past figure in.</p><p><i>This Isn't a Game</i> starts a series where Jackson will explore both crimes and new career trajectories.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Moss
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5cd2a9cc